import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';

const gridSize = gridSizeFn();

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SwitcherWrapper = styled.div({
	maxHeight: 'calc(100vh - 100px)',
});

const SKELETON_ITEM_COUNT = 3;
const skeletonItemHeight = 32 + gridSize * 4;

const totalSkeletonItemsHeight = skeletonItemHeight * SKELETON_ITEM_COUNT;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SwitcherContent = styled.div({
	padding: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${totalSkeletonItemsHeight + gridSize}px`,
});

type Props = {
	children: ReactNode;
};

export const StyledSwitcherContainer = ({ children }: Props) => (
	<SwitcherWrapper>
		<SwitcherContent>{children}</SwitcherContent>
	</SwitcherWrapper>
);
